module.exports = __webpack_public_path__ + "img/T7S game preview 1.706f60e1.webp";